<script setup lang="ts">
import { AppSelect } from '@shared/ui/selects'

import {
  useSelectAlertType,
} from '../../../../model/additional-info/success/info-health-check/select-alert-type.hook'

defineOptions({
  name: 'SelectAlertType',
})

const {
  placeholder,
  model,
  options,
} = useSelectAlertType()
</script>

<template>
  <AppSelect
    v-model="model"
    :options="options"
    :placeholder="placeholder"
  />
</template>
